import * as React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { StringIfPlural } from "react-i18next";

const defaultOptions = [
  "Create a merge commit",
  "Squash and merge",
  "Rebase and merge",
];

export default function MuiFilterButton ({
  options = defaultOptions,
  variant = "contained",
  onClick = () => { },
}: FilterProps) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleClick = (id = options[selectedIndex]) => {
    console.info(`You clicked ${id}`);
    onClick(id);
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index);
    setOpen(false);
    onClick(index);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <ButtonGroup
        color="primary"
        sx={{
          height: "40px",
          background: `${variant == "contained" ? "#FF9800" : "transparent"}`,
        }}
        variant={variant}
        ref={anchorRef}
        aria-label="split button"
      >
        {options[0] == "Actions" ?
          <Button
            sx={{
              height: "40px",
              background: `${variant == "contained" ? "#FF9800" : "transparent"}`,
              color: "white",
            }}
            onClick={() => handleClick('0')}
          >
            Actions
          </Button>
          :
          <Button
            sx={{
              height: "40px",
              background: `${variant == "contained" ? "#FF9800" : "transparent"}`,
              color: "white",
            }}
            onClick={() => handleClick()}
          >
            {options[selectedIndex]}
          </Button>}
        <Button
          style={{
            background: `${variant == "contained"
              ? "rgb(179, 107, 1)"
              : "rgba(255, 152, 0, 0.08)"
              }`,
            color: "white",
          }}
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper open={open} anchorEl={anchorRef.current} transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (

                    option != "Actions" &&
                    <MenuItem
                      key={option}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}
type FilterProps = {
  options: Array<string>;
  variant?: "text" | "outlined" | "contained";
  onClick?: (e: any) => void;
};
